var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{class:_vm.labelClass,attrs:{"for":_vm.referenceId},domProps:{"innerHTML":_vm._s(_vm.label + [_vm.required ? '*' : ''])}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }